import React from 'react';
import {Button} from 'reactstrap';
import Icon from './Icon.tsx';
import {ShrinkIcon} from 'lucide-react';
import {isRenderMode} from '../../lib/tabView.ts';

interface FocusModeExitControlProps {
    onExit: () => void;
    label?: string;
}

// Not on the render page, which takes pictures of the tab alone.
const FocusModeExitControl: React.FC<FocusModeExitControlProps> = ({
    onExit,
    label = 'Back to project'
}) => isRenderMode() ? null : (
    <Button
        type="button"
        color="light"
        className="focus-mode-control focus-mode-control--exit"
        onClick={onExit}
        title={`${label} (Esc)`}
        aria-label={`${label} (Escape)`}
    >
        <Icon icon={ShrinkIcon} />
        <span>{label}</span>
    </Button>
);

export default FocusModeExitControl;
